import { List } from "immutable";
import { RecentDesigns } from "records/RecentDesign";
import BaseList from "records/BaseList";

import {
  RECENT_DESIGNS_ASYNC_ACTION_START,
  RECENT_DESIGNS_ASYNC_ACTION_SUCCESS,
  RECENT_DESIGNS_ASYNC_ACTION_ERROR,
} from "actions/recentDesigns";

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [RECENT_DESIGNS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [RECENT_DESIGNS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [RECENT_DESIGNS_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: RecentDesigns(action.data),
    });
  },
};

export default function recentDesigns(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
